import {
  Amazon,
  customSources,
  File,
  sourceList,
  type SourceProps,
  Url,
} from 'features/project-form/features/source/components/source-providers-utils'
export type { SourceProps }
import { transformSourceType } from 'features/project-form/features/source/utils'
import { UploadType } from 'features/project-form/utils/enums'

export const SourceProvider = (props: SourceProps): JSX.Element | null => {
  if (!props.sourceType || props.sourceType.length === 0) return null
  const sourceType = transformSourceType(props.sourceType)
  if (customSources.includes(sourceType)) {
    const Component = sourceList[sourceType]
    if (!Component) return null
    return <Component {...props} />
  }
  if (props.sourceType === UploadType.File) {
    return File ? <File {...props} /> : null
  }
  if (props.sourceType === 'Amazon') {
    return Amazon ? <Amazon {...props} /> : null
  }
  return Url ? <Url {...props} /> : null
}
